import React from "react";
import { MEMBERSHIP_OFFERING_PRICE_CHOICES } from "ui/pages/ManageBrandedCommunity/components/AddBonusOfferingModal/constants/AddBonusOfferingModal.constants";
import { DiscountedPriceField } from "../modules/DiscountedPriceField/DiscountedPriceField";

export const editVariationFieldMapping = ({
  handleOptionChange,
  selectedOption,
  membershipId,
}) => {
  return [
    {
      label: "At a discounted price",
      onClick: () =>
        handleOptionChange({
          value: MEMBERSHIP_OFFERING_PRICE_CHOICES.AT_DISCOUNTED_PRICE,
          membershipId: membershipId,
        }),
      checked: selectedOption({
        optionKey: MEMBERSHIP_OFFERING_PRICE_CHOICES.AT_DISCOUNTED_PRICE,
        membershipId: membershipId,
      }),
      belowLabel: <DiscountedPriceField membershipId={membershipId} />,
    },
    {
      label: "Free of cost",
      onClick: () =>
        handleOptionChange({
          value: MEMBERSHIP_OFFERING_PRICE_CHOICES.FREE_OF_COST,
          membershipId: membershipId,
        }),
      checked: selectedOption({
        optionKey: MEMBERSHIP_OFFERING_PRICE_CHOICES.FREE_OF_COST,
        membershipId: membershipId,
      }),
    },
    {
      label: "Don’t show this variation to this membership",
      onClick: () =>
        handleOptionChange({
          value: MEMBERSHIP_OFFERING_PRICE_CHOICES.NOT_INCLUDED,
          membershipId: membershipId,
        }),
      checked: selectedOption({
        optionKey: MEMBERSHIP_OFFERING_PRICE_CHOICES.NOT_INCLUDED,
        membershipId: membershipId,
      }),
    },
  ];
};
